import { render, staticRenderFns } from "./AnxTitle.vue?vue&type=template&id=45a04698&scoped=true&"
import script from "./AnxTitle.vue?vue&type=script&lang=ts&"
export * from "./AnxTitle.vue?vue&type=script&lang=ts&"
import style0 from "./AnxTitle.vue?vue&type=style&index=0&id=45a04698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a04698",
  null
  
)

export default component.exports